import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as qs from 'querystring';
import { Helper } from '../helpers/helper';

@Injectable()
export class ClientesReport  {

  constructor(private _http: HttpClient, private helper: Helper ) {  }

  // Cargar registro de reportes de clientes atrasos
  obtenerClienteVencidos(ID_RUTA = 0) {
    return this._http.get(`${this.helper.urlServer}/api/v1/reporte/clientes-vencidos/${ ID_RUTA }`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  // Cargar registro de reportes de clientes atrasos
  filtroClienteVencidos( id_ruta: number ) {

    let clientesVencidosDB: any = [];
    const clientesVencidosArr: any = [];

    this.obtenerClienteVencidos().subscribe( resp => {
      clientesVencidosDB = resp;
    } );


    return clientesVencidosArr;

  }


}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/clientes.reports.service.ts